import React from 'react';
import queryString from 'query-string';
import { withRouter, RouteChildrenProps } from 'react-router';
import { FormattedMessage } from 'react-intl';

import arrow from 'four-nets/icons/svg/icon_arrow-down.svg';
import times from 'four-nets/icons/svg/icon_delete_2.svg';
import thlarge from 'four-nets/icons/svg/icon_menu-sub.svg';

import SVGIcon from 'lib/images/svg-icon/svg-icon';
import Styled from 'styled';
import { InterscrollerContext } from 'lib/google/dfp/ad-units/interscroller';

import SearchInput from 'four-nets/ui-v2/search-input/search-input';
import { Category } from 'four-nets/bazaar/bazaar';
import { Checkboxes } from './checkboxes/checkboxes';

import searchInputStyles from './search-input-view.scss';
import defaultStyles from './filter-panel-view.scss';
import thlargeiconStyles from './filter-panel-thlargeicon.scss';

export interface Props extends RouteChildrenProps {
    styles: typeof defaultStyles;
    activeCategory?: Category;
    openHeight: number | string;
    onVendorChange: () => void;
    onUsedChange: () => void;
    excludeVendor: boolean;
    excludeUsed: boolean;
}

export interface State {
    hidden: boolean;
    searchValue: string;
}

class FilterPanelView extends React.Component<Props, State> {
    state = {
        hidden: false,
        searchValue: '',
    };

    static contextType = InterscrollerContext;

    toggleHidden = () => {
        this.setState(prevState => ({
            hidden: !prevState.hidden,
        }));
    };

    componentDidUpdate(prevProps: Props, prevState: State) {
        if (prevState.hidden !== this.state.hidden && this.context.updateOffsetTop) {
            this.context.updateOffsetTop();
        }
    }

    close = () => {
        this.props.history.push('/market/');
    };

    onSubmit = (event: React.ChangeEvent<HTMLFormElement>) => {
        event.preventDefault();

        this.props.history.push({
            pathname: this.props.location.pathname,
            search: `?${queryString.stringify({
                ...queryString.parse(this.props.location.search),
                search: this.state.searchValue,
                page: 1,
            })}`,
        });
    };

    onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({ searchValue: event.target.value });
    };

    componentDidMount() {
        if (this.props.activeCategory) {
            this.setState({
                hidden: true,
            });
        }
    }

    render() {
        const { activeCategory, openHeight, styles, ...rest } = this.props;

        const classNames = [styles.filterPanel];
        if (this.state.hidden) {
            classNames.push(styles.hidden);
        }
        const buttonContentStyles = [styles.buttonContent];
        if (activeCategory && activeCategory.name && activeCategory.name.length > 16) {
            buttonContentStyles.push(styles.mediumSize);
        }

        return (
            <div className={classNames.join(' ')}>
                <div className={styles.headingPanel}>
                    <h2 className={styles.heading}>
                        <div className={styles.buttonWrapper}>
                            {activeCategory ? (
                                <button className={styles.closeButton} onClick={this.close}>
                                    <SVGIcon src={times} className={styles.timesIcon} />
                                </button>
                            ) : null}
                            <button className={styles.button} onClick={this.toggleHidden}>
                                <span className={buttonContentStyles.join(' ')}>
                                    {!activeCategory ? (
                                        <SVGIcon style={{ image: thlargeiconStyles.thlargeIcon }} src={thlarge} />
                                    ) : null}
                                    {(activeCategory && activeCategory.name) || (
                                        <FormattedMessage id='BAZAAR_CATEGORIES' />
                                    )}
                                    <SVGIcon style={{ image: styles.icon }} src={arrow} />
                                </span>
                            </button>
                        </div>
                    </h2>

                    <SearchInput
                        style={{
                            searchInput: searchInputStyles.searchInput,
                            iconWrapper: searchInputStyles.iconWrapper,
                            input: searchInputStyles.input,
                        }}
                        onChange={this.onChange}
                    />
                    <Checkboxes {...rest} />
                </div>
                <div
                    className={styles.contentWrapper}
                    style={{
                        maxHeight: openHeight,
                        transition: `all ${1500}ms ease-out`,
                    }}
                >
                    {this.props.children}
                </div>
            </div>
        );
    }
}

export default Styled(defaultStyles)(withRouter<any, any>(FilterPanelView));
